module.exports = "/assets/data/f92a521974eef006c07e18d08a76f3f5-EC4Y.data.json";